import PageHeader from "@/components/PageHeader";
import PartyPlanner from "@/components/PartyPlanner";
import Events from "@/components/Events";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function EventsPage() {
  useSeo({
    title: "Parties & Group Events | Cool Runnings Cape Town",
    description:
      "Birthday parties, school trips and corporate team building on Africa's first downhill toboggan track. Dedicated coordinators, platters and a licensed bar.",
    keywords:
      "kids birthday party venue Cape Town, school trips Cape Town, corporate team building Cape Town, group bookings toboggan park, sports day venue Cape Town",
    image: "/og/events.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Events & Groups"
        eyebrow="Events & group outings"
        title="BIG DAYS OUT"
        subline="Corporate team building, school outings and birthday parties — we handle the track, the tables and catering."
        image="/park-party.jpg"
      />
      <Events />
      <PartyPlanner />
      <CtaBand />
    </>
  );
}
